import React from 'react'

import { cn } from 'src/shared/utils/cn'

import FilterGrain from '../image/filter-grain'

const getVideoMimeType = (src: string): string | undefined => {
  const extension = src.split('.').pop()?.toLowerCase()

  // Common video mime types, add more as needed.
  const mimeTypes: Record<string, string> = {
    webm: 'video/webm',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
  }
  return extension ? mimeTypes[extension] : undefined
}

interface WebmVideoProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  /** Video source URL */
  src: string
  /** A fallback video to use if the webm video is not supported. E.g. mp4, etc. */
  fallbackSrc?: string
  className?: string
  containerClassName?: string
  includeFilterGrain?: boolean
}

/**
 * A component that renders a webm video and a fallback video.
 */
const WebmVideo = React.forwardRef<HTMLVideoElement, WebmVideoProps>(
  ({ src, className, fallbackSrc, containerClassName, includeFilterGrain, ...props }, ref) => {
    const isWebm = src.toLowerCase().endsWith('.webm')
    const fallbackMimeType = fallbackSrc ? getVideoMimeType(fallbackSrc) : undefined

    return (
      <div className={cn('size-full', includeFilterGrain && 'relative', containerClassName)}>
        <video className={cn('size-full object-cover', className)} {...props} ref={ref}>
          {isWebm && <source type="video/webm" src={src} />}
          {fallbackSrc && <source src={fallbackSrc} type={fallbackMimeType} />}
        </video>
        {includeFilterGrain && <FilterGrain />}
      </div>
    )
  },
)

WebmVideo.displayName = 'WebmVideo'

export default WebmVideo
